import { Cities, Province } from "../type/province-city.types";
import data from "./province-city.json";

export let cities: Cities = {};

export const provinces: Province[] = Object.keys(data).map((province) => {
  cities[province] = data[province as keyof typeof data].map((value) => ({
    key: value.Municipality,
    value: value.Municipality,
    label: value.Municipality,
  }));

  return {
    key: province,
    value: province,
    label: province,
  };
});
